export class MenuResizer {
    resizing = false;
    startX: number;
    startWidth: number;
    menuWidth: number;

	onMenuResize(event: any) {
        this.resizing = true;
        this.startX = event.pageX;
        this.startWidth = this.menuWidth;
		event.preventDefault();
    }

    mouseMove(event: MouseEvent) {
        if (this.resizing && event.buttons) {
            const total = event.pageX - this.startX;
            const soFar = this.menuWidth - this.startWidth;
            const delta = total - soFar;
            const newWidth = this.menuWidth + delta;

            if (newWidth >= 150) {
                this.menuWidth = newWidth;
            }
        }
	}

	mouseMoveMinMax(event: MouseEvent, minWidth: number, maxWidth: number) {
		if (this.resizing && event.buttons) {
			const total = event.pageX - this.startX;
			const soFar = this.menuWidth - this.startWidth;
			const delta = total - soFar;
			const newWidth = this.menuWidth + delta;

			if (delta >= 0) {
				this.menuWidth = newWidth >= maxWidth ? maxWidth : newWidth;
			}
			else {
				this.menuWidth = newWidth < minWidth ? minWidth : newWidth;
			}
		}
	}

    mouseUp() {
        this.resizing = false;
    }

	constructor(params?: MenuResizerParams) {
		this.menuWidth = params?.menuWidth || 340;
	}
}


interface MenuResizerParams {
	menuWidth: number;
}
